import './index.css';
import { useTranslation } from 'react-i18next';
import { dispatch } from '../../../redux/store';
import { IoMdSettings } from 'react-icons/io';
import { setActivePanel } from '../../../redux/slices/panelSlice';
import PostEditorActions, { EditorBackButton } from './post-editor-actions';

const SettingsPopover = ({ editor }) => {
  const { t } = useTranslation();

  return (
    <div className="settings-container flex justify-between">
      <EditorBackButton />

      <button
        onClick={() => dispatch(setActivePanel('outline'))}
        className="flex rounded-md items-center text-sm hover:bg-neutral-200 px-4 transition-all ease-in"
      >
        <IoMdSettings size={15} />
        <p className="ml-1 hidden sm:block">{t('Settings', 'Réglages')}</p>
      </button>

      <PostEditorActions />
    </div>
  );
};

export default SettingsPopover;
